import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { client } from '../interfaces'

const Confirm = () => {
  const history: any = useHistory()
  const client: client = history.location.state.client
  const handleClick = (): void => {
    history.push({
      pathname: '/form',
      state: { client: client }
    })
  }
  return (
    <React.Fragment>
      <div className='container grid justify-items-center md:mx-auto'>
        <h2 className='mt-32 mb-5 text-2xl font-sans text-center w-10/12 leading-6'>
          Tu pago será realizado a nombre de:
        </h2>
        <div className='grid w-full h-auto bg-black justify-items-center'>
          <h2 className='mt-10 mb-5 text-4xl font-sans align-middle text-center w-10/12 leading-6 text-white'>
            {client.name}
          </h2>
          <h2 className='mt-2 mb-10 text-4xl font-sans align-middle text-center w-10/12 leading-6 text-white'>
            {client.phone}
          </h2>
        </div>
        <h2 className='mt-28 mb-5 text-3xl font-sans align-middle text-center w-10/12 leading-6'>
          ¿Deseas Continuar?
        </h2>
        <button
          type='button'
          className='bg-black active:bg-gray-800 rounded-full h-14 w-80 text-center text-white text-3xl mb-28'
          onClick={handleClick}>
          Siguiente
        </button>
        <Link to='/'>
          <button
            type='button'
            className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-3xl'>
            Cancelar
          </button>
        </Link>
      </div>
    </React.Fragment>
  )
}

export default Confirm
